/* eslint no-param-reassign: ["error", { "props": false }] */
/**
 * @param  {htmlNode} domNode dom element containing text to be replaced
 * @param  {string} text text string to replace current text with
 */
export default function(domNode, text) {
  if (!domNode || typeof text === 'undefined' || text === null || typeof text === 'object') {
    return;
  }

  // turn text to string and trim trailing/leading spaces
  const trimmedText = String(text).trim();

  // check new text against current text
  const currentText = domNode.textContent;
  if (currentText !== trimmedText) {
    domNode.textContent = trimmedText;
    domNode.setAttribute('data-updated', 'true');
  } else {
    domNode.removeAttribute('data-updated');
  }
}
